module.exports = __webpack_public_path__ + "static/media/business.7ea81b8a.png";